import { render, staticRenderFns } from "./HighlightIcon.vue?vue&type=template&id=2fd90eb3&"
import script from "./HighlightIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HighlightIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports